import React, { FC } from 'react';

interface PackageIconProps {
  width?: number;
  height?: number;
  fill?: string;
  classes?: string;
}

const PackageIcon: FC<PackageIconProps> = ({
  width = 20,
  height = 20,
  fill = '#424140',
  classes = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      className={classes}
    >
      <path
        d="M11.0478 21.6097V12.5469L3.11299 7.95197V16.7952C3.11299 16.8601 3.12928 16.9212 3.16187 16.9783C3.19446 17.0352 3.24323 17.084 3.30819 17.1246L11.0478 21.6097ZM12.9522 21.6097L20.6918 17.1246C20.7568 17.084 20.8055 17.0352 20.8381 16.9783C20.8707 16.9212 20.887 16.8601 20.887 16.7952V7.95197L12.9522 12.5469V21.6097ZM10.8526 23.6874L2.35633 18.797C1.99492 18.5888 1.71329 18.3105 1.51143 17.9622C1.30956 17.6137 1.20863 17.2312 1.20863 16.8145V7.18546C1.20863 6.76883 1.30956 6.38627 1.51143 6.03777C1.71329 5.68948 1.99492 5.41124 2.35633 5.20303L10.8526 0.312633C11.2138 0.104212 11.5963 0 12 0C12.4037 0 12.7862 0.104212 13.1474 0.312633L21.6437 5.20303C22.0051 5.41124 22.2867 5.68948 22.4886 6.03777C22.6904 6.38627 22.7914 6.76883 22.7914 7.18546V16.8145C22.7914 17.2312 22.6904 17.6137 22.4886 17.9622C22.2867 18.3105 22.0051 18.5888 21.6437 18.797L13.1474 23.6874C12.7862 23.8958 12.4037 24 12 24C11.5963 24 11.2138 23.8958 10.8526 23.6874ZM16.8952 8.06433L19.8396 6.37484L12.1952 1.95324C12.1302 1.91261 12.0652 1.8923 12 1.8923C11.9348 1.8923 11.8698 1.91261 11.8048 1.95324L9.04824 3.5402L16.8952 8.06433ZM12 10.9063L14.9518 9.1971L7.11215 4.66568L4.16039 6.37484L12 10.9063Z"
        fill={fill}
      />
    </svg>
  );
};

export default PackageIcon;
